import KineticMaterialBase from 'eflex/models/kinetic-material-base';
import { belongsTo, hasMany } from '@ember-data/model';

export default class KineticOperationMaterial extends KineticMaterialBase {
  @belongsTo('kinetic-operation', { inverse: 'materials', async: false }) operation;
  @hasMany('task', { inverse: 'materials', async: false }) task;
}
